export default __webpack_public_path__ + "static/media/text-align-center.628fab5f.svg";